export default {
  version: 'Version {version}',
  empty: 'The highlights of new Qmulus versions appear here.',
  releaseNotes: 'All changes in release {version}',
  versions: 'Versions',
};
